import { render, staticRenderFns } from "./peachForm.vue?vue&type=template&id=8f66385a&scoped=true&"
import script from "./peachForm.vue?vue&type=script&lang=js&"
export * from "./peachForm.vue?vue&type=script&lang=js&"
import style0 from "./peachForm.vue?vue&type=style&index=0&id=8f66385a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f66385a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f66385a')) {
      api.createRecord('8f66385a', component.options)
    } else {
      api.reload('8f66385a', component.options)
    }
    module.hot.accept("./peachForm.vue?vue&type=template&id=8f66385a&scoped=true&", function () {
      api.rerender('8f66385a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/views/peachForm.vue"
export default component.exports